module.exports = __webpack_public_path__ + "static/media/marufPhoto.8a82b63b.jpg";